module.exports = __webpack_public_path__ + "img/KimKania.9a93a798.jpg";